var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3H3L3 7.5H7.5V3ZM3 2C2.44772 2 2 2.44772 2 3V7.5C2 8.05228 2.44772 8.5 3 8.5H7.5C8.05228 8.5 8.5 8.05228 8.5 7.5V3C8.5 2.44772 8.05228 2 7.5 2H3Z",
    fill: "#CFD8E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.5H3L3 15H7.5V10.5ZM3 9.5C2.44772 9.5 2 9.94772 2 10.5V15C2 15.5523 2.44772 16 3 16H7.5C8.05228 16 8.5 15.5523 8.5 15V10.5C8.5 9.94772 8.05228 9.5 7.5 9.5H3Z",
    fill: "#CFD8E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H10.5L10.5 7.5H15V3ZM10.5 2C9.94772 2 9.5 2.44772 9.5 3V7.5C9.5 8.05228 9.94772 8.5 10.5 8.5H15C15.5523 8.5 16 8.05228 16 7.5V3C16 2.44772 15.5523 2 15 2H10.5Z",
    fill: "#CFD8E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.5H10.5L10.5 15H15V10.5ZM10.5 9.5C9.94772 9.5 9.5 9.94772 9.5 10.5V15C9.5 15.5523 9.94772 16 10.5 16H15C15.5523 16 16 15.5523 16 15V10.5C16 9.94772 15.5523 9.5 15 9.5H10.5Z",
    fill: "#CFD8E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b27e8f2f2ac93e292d8918d0a72366aa.svg";
export { ForwardRef as ReactComponent };